import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

const defaultData: { [key: string]: string; } = {
    title: 'Здесь пока пусто',
    description: 'Запрашиваемая страница пустая'
};

@Component({
    selector: 'no-content',
    templateUrl: './no-content.component.html',
    styleUrls: ['./no-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoContentComponent implements OnInit {
    public icons: any;
    public title: string;
    public description: string;

    constructor(private route: ActivatedRoute) { }

    public ngOnInit() {
        const { title, description } = this.route.snapshot.data;

        this.title = title || defaultData.title;
        this.description = description || defaultData.description;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/no-content/no-content.component.ts